// extracted by mini-css-extract-plugin
export default {"root":"dO3Cgfvn_g"};